const api = {
    login: process.env.REACT_APP_URL + '/admin/login',
    admin : process.env.REACT_APP_URL + '/admin',
    get_otps: process.env.REACT_APP_URL + '/admin/get_otps',
    tmp_manual_adjust_profit: process.env.REACT_APP_URL + '/admin/tmp_manual_adjust_profit',
    tmp_manual_purchase_package: process.env.REACT_APP_URL + '/admin/tmp_manual_purchase_package',
    change_password: process.env.REACT_APP_URL + '/admin/change_password',
    dashboard: process.env.REACT_APP_URL + '/admin/dashboard',
    get_rank: process.env.REACT_APP_URL + '/setting/get_value?key=rcfx_rank',
    lookup_sponsor: process.env.REACT_APP_URL + '/admin/lookup_sponsor',
    direct_downline: process.env.REACT_APP_URL + '/admin/direct_downline',
    withdraw_action: process.env.REACT_APP_URL + '/admin/withdraw_action',
    get_orders: process.env.REACT_APP_URL + '/admin/get_orders',
    get_order_details: process.env.REACT_APP_URL + '/admin/get_order',
    add_admin: process.env.REACT_APP_URL + '/admin/add_user',
    get_admin: process.env.REACT_APP_URL + '/admin/get_users',
    get_admin_details: process.env.REACT_APP_URL + '/admin/get_user',
    edit_admin: process.env.REACT_APP_URL + '/admin/edit_user',
    remove_user: process.env.REACT_APP_URL + '/admin/remove_user',
    tmp_deposit_to_customer: process.env.REACT_APP_URL + '/admin/tmp_deposit_to_customer',
    get_customer_details: process.env.REACT_APP_URL + '/admin/get_customer',
    reset_customer_transaction_password: process.env.REACT_APP_URL + '/admin/reset_customer_transaction_password',
    reset_customer_password: process.env.REACT_APP_URL + '/admin/reset_customer_password',
    get_customers: process.env.REACT_APP_URL + '/admin/get_customers',
    team_detail: process.env.REACT_APP_URL + '/admin/team_detail',
    get_customer_approvals: process.env.REACT_APP_URL + '/admin/get_customer_approvals',
    get_wallet_overview: process.env.REACT_APP_URL + '/admin/get_wallet_overview',
    get_wallets: process.env.REACT_APP_URL + '/admin/get_wallets',
    get_customer_rank_logs: process.env.REACT_APP_URL + '/admin/get_customer_rank_logs',
    wallet_adjust: process.env.REACT_APP_URL + '/admin/wallet_adjust',
    get_announcements: process.env.REACT_APP_URL + '/announcement/get_announcements',
    get_announcement_details: process.env.REACT_APP_URL + '/announcement/get_announcement',
    add_announcement: process.env.REACT_APP_URL + '/announcement/add_announcement',
    edit_announcement: process.env.REACT_APP_URL + '/announcement/edit_announcement',
    get_mt5_accounts: process.env.REACT_APP_URL + '/admin/get_mt5_accounts',
    get_mt5_deal_details: process.env.REACT_APP_URL + '/admin/get_mt5_deal_details',
    get_permissions: process.env.REACT_APP_URL + '/permission/get_permissions',
    get_settings: process.env.REACT_APP_URL + '/setting/get_settings',
    add_settings: process.env.REACT_APP_URL + '/setting/add_settings',
    upload_rank_image: process.env.REACT_APP_URL + '/upload/upload_rank',
    edit_customer_mt5: process.env.REACT_APP_URL + '/admin/edit_customer_mt5',
    get_mt5_group: process.env.REACT_APP_URL + '/setting/get_value?key=rcfx_user_group',
    generate_lot_rebate: process.env.REACT_APP_URL + '/admin/generate_lot_rebate',
    generate_profit: process.env.REACT_APP_URL + '/admin/generate_profit',
}

export { api };